import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { from, lastValueFrom } from "rxjs";
import { environment } from "@env";
import {coreDevice} from "@core/r2";

export const deviceHashInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.startsWith(environment.office_api_host)) return next(req);

    return from(deviceHash(req, next))
};

const deviceHash = async (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const deviceHashHeader = req.headers.get('x-device-hash') || await coreDevice.Info.GetHash();

    const modified = req.clone({
        setHeaders: { 'X-Device-Hash': deviceHashHeader }
    });

    return await lastValueFrom(next(modified));
};
